
(function roleAddControllerDefinition() {
    'use strict';

    angular.module('Role')
        .controller('RoleAddController', [
            '$scope', 'config', '$state', '$translate', 'errorsExtend', 'adminRoleService', 'authExtend', 'adminContainerTypeService', 'adminDocumentTypeService', '$filter',
            function roleAddController($scope, config, $state, $translate, errors, adminRoleService, authExtend, adminContainerTypeService, adminDocumentTypeService, $filter) {
                $scope.title = 'RoleAdd';

                $scope.role = {
                    name: "",
                    organizationalUnitId: authExtend.getOrganizationId(),
                    organizationalUnitName: authExtend.getOrganizationName(),
                    containerTypes: undefined,
                    documentTypes: undefined
                };

                $scope.requiredOu = authExtend.getOrganizationId() ? true : false;


                $scope.save = function () {
                    if (!$scope.roleForm.$valid || !$scope.role.containerTypes || !$scope.role.documentTypes) {
                        errors.showError('VerifyFormData');
                        return false;
                    }

                    var containerTypes = $filter('filter')($scope.role.containerTypes, { organizationalUnitId: null }, true);

                    var documentTypes = $filter('filter')($scope.role.documentTypes, { organizationalUnitId: null }, true);

                    return adminRoleService.create($scope.role).then(function (role) {
                        $state.go('role-functions', { id: role.id });
                    },
                        function (error) {
                            errors.showError(error);
                        });
                };

                $scope.cancel = function () {
                    $state.go("role-find");
                };

                $scope.load = function () {
                    adminContainerTypeService.get().then(function (containerTypes) {
                        $scope.role.containerTypes = containerTypes;
                    },
                        function (error) {
                            errors.showError(error);
                            $scope.cancel();
                        });

                    adminDocumentTypeService.get().then(function (docu) {
                        $scope.role.documentTypes = docu;
                    },
                        function (error) {
                            errors.showError(error);
                            $scope.cancel();
                        });
                }

                $scope.load();
            }
        ]);
})();